import { Skeleton as AntdSkeleton } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { SkeletonProps } from 'antd';

export const Skeleton = createGuardedComponent(AntdSkeleton) as typeof AntdSkeleton;
